module.exports = __webpack_public_path__ + "img/6-1_06.b20ed448.gif";